import { render, staticRenderFns } from "./AINotebooks.vue?vue&type=template&id=71ddc779&lang=pug"
import script from "./AINotebooks.vue?vue&type=script&lang=js"
export * from "./AINotebooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports